<template lang="pug">
  #ReservationIndex
    h5.text-center.py-3.letter-spacing-6 我的客戶
    .bg-light.mb-3
      .px-2.py-3
        b-row(
          no-gutters
        )
          b-col(
            cols=3,
            class="d-flex align-items-center"
          )
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="memberInfo ? memberInfo.picture_url : 'xxx'",
              :style="{ 'width': '60px', 'height': '60px' }"
            )
          b-col(
            cols=9
          )
            p.mb-0.font-weight-bold.text-17 {{ memberInfo ? `${memberInfo.customer_chinese_last_name} ${memberInfo.customer_chinese_first_name}` : '' }}
            b-row(
              no-gutters
            )
              b-col(
                cols="6",
                class="d-flex align-items-center mb-2"
              )
                small 暱稱名：{{ memberInfo ? memberInfo.line_display_name : '-' }}
              b-col(
                :cols="editMode ? 12 : 6",
                class="mb-2"
              )
                .d-flex.align-items-center(
                  v-if="memberInfo"
                )
                  small(
                    style="flex: 0 0 auto;"
                  ) 備註名：
                  small(
                    v-if="!editMode"
                  ) {{ noteName }}
                  b-input.d-inline-block(
                    v-model="noteName",
                    v-if="editMode",
                    class="rounded-0 p-1"
                  )
                  b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-1.button.iconBtn.iconEditBtn(
                    variant="primary",
                    @click="editModeHandler()",
                    width="10",
                    height="10"
                  )
                    i.fas.fa-pencil-alt.iconEdit.fa-sm
              b-col(
                cols="12",
                class="d-flex align-items-center mb-2"
              )
                small ECM ID：{{ memberInfo ? memberInfo.member_code : '' }}
              b-col(
                cols="6",
                class="d-flex align-items-center mb-2"
              )
                small.mb-0 客戶TR：
                b-badge(
                  variant="primary",
                  class="rounded-0 p-1 bg-primary"
                ) {{ memberInfo ? TRList.includes(memberInfo.member_level) ? memberInfo.member_level : '' : ''}}
              b-col(
                cols="6",
                class="d-flex align-items-center mb-2"
              )
                small.mb-0 性別：
                b-badge(
                  variant="primary",
                  class="rounded-0 p-1 bg-primary"
                ) {{ memberInfo ? genderList.includes(memberInfo.member_gender) ? memberInfo.member_gender : '' : ''}}
      b-row(
        no-gutters,
        class="align-items-center bg-primary py-2 px-3 mb-2"
      )
        .col-6
          .d-flex.align-items-center
            i.fas.fa-birthday-cake.mr-2
            small 生日：{{ memberInfo ? filterMonthToWord(memberInfo.birthday) : ''}}
        .col-6
          small 上次到店資訊日期：{{ memberInfo ? memberInfo.latest_reservation_date : ''}}
        .col-6
          .d-flex.align-items-center
            i.fas.fa-mobile-alt.mr-2
            small 電話：{{ memberInfo ? memberInfo.mobile : ''}}
        .col-6
          small 上次服務CA：{{ memberInfo ? memberInfo.latest_reservation_sa_name : ''}}
      b-row(
        no-gutters
        class="mb-3 button-row"
      )
        b-col(
          cols=6,
          class="button-item-first"
        )
          b-button(
            block,
            :variant=" nowSelectItem === '客戶資料' ? 'primary selected' : 'outline-primary' ",
            @click="changeTypeHandler('客戶資料')",
            class="border-gray text-black"
          ) 客戶資料
        b-col(
          cols=6
        )
          b-button(
            block,
            :variant=" nowSelectItem === '預約紀錄' ? 'primary selected' : 'outline-primary' ",
            @click="changeTypeHandler('預約紀錄')",
            class="border-gray text-black"
          ) 預約紀錄
      .customerInfo.px-3.mb-3(
        v-show="nowSelectItem === '客戶資料'"
      )
        small.mb-1.font-weight-bold.d-block 客戶標籤：
        multiselect.mb-2(
          v-model="userLabels",
          tag-placeholder="新增標籤",
          placeholder="輸入文字新增標籤",
          selectLabel="",
          :showLabels="false",
          deselectLabel="點擊移除標籤",
          selectedLabel="已選擇",
          label="tag_name",
          track-by="tag_id",
          :options="tagsOption",
          :multiple="true",
          @remove="removeLabelHandler",
          @select="selectLabelHandler"
          noOptions="無標籤"
        )
          span(slot="noResult")
        small.mb-1.font-weight-bold.d-block 客戶描述：
        b-textarea(
          :disabled="memberInfo ? memberInfo.member_id == null : true",
          v-model="desc",
          class="mb-2"
        )
        .text-center
          b-button(
            :disabled="memberInfo ? memberInfo.member_id == null : true",
            size="sm",
            variant="white",
            @click="updateDescriptionHandler()",
            class="bg-white border-gray rounded-0"
          ) 更新
      .reservationInfo.mb-3(
        v-show="nowSelectItem === '預約紀錄'"
      )
        b-row(
          no-gutters
          class="mb-3 button-row px-4"
        )
          b-col(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectStatus === 'reserving' ? 'primary selected' : 'light' ",
              @click="changeStatusHandler('reserving')"
            ) 申請預約
          b-col(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectStatus === 'checked' ? 'primary selected' : 'light' ",
              @click="changeStatusHandler('checked')"
            ) 完成預約
          b-col(
            cols=4,
            class="border-right border-black"
          )
            b-button(
              block,
              :variant=" nowSelectStatus === 'success' ? 'primary selected' : 'light' ",
              @click="changeStatusHandler('success')"
            ) 到店諮詢
        b-row(
          no-gutters
          class="mb-3 button-row px-4"
        )
          b-col(
            cols=12
          )
            multiselect(
              v-model="selectType",
              placeholder="選擇預約狀態",
              selectLabel="已選擇預約狀態",
              :showLabels="false",
              selectedLabel="已選擇",
              label="title",
              track-by="id",
              :options="typeOption",
              :multiple="false",
              :taggable="false",
              :searchable="false",
              :allowEmpty="false",
              @select="changeStatusHandler"
              noOptions="無標籤"
            )
          template(slot="Label", slot-scope='{ tags }')
        b-card.border-0.mb-2.customerCard.overflow-hidden(
          bg-variant="light",
          v-for="(reservation,index) in reservations",
          :key="reservation.id"
        )
          .reserveAtRow.mb-2.d-flex.align-items-center
            i.far.fa-calendar-check.mr-2
            small 預約時間：{{ reservation.reserve_date }} {{ reservation.start_time }} ~ {{ reservation.end_time }}
          .typeRow.mb-2.d-flex.align-items-center
            i.fas.fa-border-all.mr-2
            small(v-if="reservation.reserve_type_name !== null") 服務內容：{{ reservation.reserve_type_name }}
            small(v-else-if="reservation.activity_name !== null") 參加event：{{ reservation.activity_name }} ({{ reservation.experience === 0 ? '到店體驗' : '線上體驗'}})
            small(v-else) 活動名稱：
          .mobileRow.mb-2.d-flex.align-items-center
            i.fas.fa-mobile-alt.mr-2
            small 預約手機：{{ reservation.reserve_mobile ? reservation.reserve_mobile : '' }}
          .statusRow.mb-2.d-flex.align-items-center
            i.far.fa-check-circle.mr-2
            small 預約狀態：{{ reservation.status === 'reserving' ? '申請預約' : reservation.status === 'checked' ? '完成預約' : reservation.status === 'success' ? '到店諮詢' : '-' }}
          .labelRow.d-flex.align-items-center.flex-wrap.mb-3
            i.fas.fa-tag.mr-2
            small 客戶標籤：
            b-badge.m-1.rounded-50.px-3.py-2(
              variant="primary",
              v-for="(label,index) in reservation.personnel_tags"
              :key="index"
            ) {{ label }}
          b-row(
            no-gutters,
            class="button-row"
          )
            b-col(
              :cols="4",
              v-if="reservation.status === 'reserving' || reservation.status === 'checked'"
            )
              b-button(
                block,
                size="sm",
                variant="primary",
                @click="cancelReservationHandler(reservation.reservation_id)"
              ) 取消預約
            b-col(
              cols=4,
              v-if="reservation.status === 'reserving' || reservation.status === 'checked'"
            )
              b-button(
                block,
                size="sm",
                variant="primary",
                @click="editReservationHandler(reservation)"
                v-if="reservation.reserve_type_name !== null"
              ) 修改預約
              b-button(
                block,
                size="sm",
                variant="primary",
                @click="editEventReservationHandler(reservation)"
                v-if="reservation.activity_name !== null"
              ) 修改預約
            b-col(
              cols=4,
              v-if="reservation.status === 'reserving'",
              class="border-right border-black"
            )
              b-button(
                block,
                size="sm",
                variant="primary",
                @click="confirmReservationHandler(reservation.reservation_id)"
              ) 完成預約
            b-col(
              cols=4,
              v-if="reservation.status === 'checked'",
              class="border-right border-black"
            )
              b-button(
                block,
                size="sm",
                variant="primary",
                @click="doneReservationHandler(reservation.reservation_id)"
              ) 到店諮詢
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
    b-row
      b-col(
        cols=12
      )
        b-button(
          variant="light",
          block,
          @click="$router.go(-1)",
          class="rounded-0 border-gray border-left-0 border-right-0"
        ) 回上一頁

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SA_MY_CUSTOMER_RESERVATION_EDIT } from '@/router/sa/my-customer';
import { SA_CHAT_ROOM_INDEX } from '@/router/sa/chat-room';
import { SA_CONTACTS_INDEX } from '@/router/sa/contacts';
import { SA_EVENT_ACTIVITY_RESERVATION_EDIT } from '@/router/sa/event-activity';

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    filter_type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      nowSelectItem: '客戶資料',
      infiniteId: +new Date(),
      noteName: null,
      desc: null,
      editMode: false,
      userLabels: [],
      tagsOption: [],
      customerData: {
        user: {},
        filter_type: ''
      },
      typeOption: [
        {
          id: '0',
          title: 'store'
        },
        {
          id: '1',
          title: 'event'
        }
      ],
      selectType: {
        id: '0',
        title: 'store'
      }
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    if (vm.user !== undefined || vm.filter_type !== undefined) {
      window.sessionStorage.setItem('user', JSON.stringify(vm.user));
      window.sessionStorage.setItem('filter_type', vm.filter_type);
    }

    vm.customerData.user = JSON.parse(window.sessionStorage.getItem('user'));
    vm.customerData.filter_type = window.sessionStorage.getItem('filter_type');
    vm.$store.commit('toggleLoading', false);

    let formData;

    switch (vm.customerData.filter_type) {
      case 'binding':
      case '10K':
      case 'not_binding':
        formData = {
          member_id: vm.customerData.user.member_id,
          filter_type: 'binding'
        };
      break;
      case 'others':
        formData = {
          member_line_uuid: vm.customerData.user.member_line_uuid,
          filter_type: vm.customerData.filter_type
        };
      break;
      default:
      break;
    }

    if (!formData) {
      vm.$swal.close();
      vm.$router.push({
        name: SA_CONTACTS_INDEX
      });
    }

    // 取得客戶詳細資料
    vm.$store.dispatch('sa_my_customer/getMemberDetailHandler', formData)
      .then(() => {
        vm.$set(vm, 'noteName', vm.memberInfo && vm.memberInfo.note_name ? vm.memberInfo.note_name : null);
        vm.$set(vm, 'desc', vm.memberInfo.desc);
        // 取得預約資訊
        vm.$store.dispatch('sa_my_customer/getReservationTimeListHandler')
          .then(() => {
            // 取得所有標籤
            vm.$store.dispatch('sa_my_customer/getTagsHandler')
              .then(() => {
                // 這邊先寫死拿後端的標籤，以後有時間再來改
                vm.$set(vm, 'tagsOption', vm.tags ? vm.tags[1].tag : []);
                // 取得該使用者的標籤
                vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
                  .then(() => {
                    vm.$set(vm, 'userLabels', vm.memberTags);
                    vm.$swal.close();
                  });
              });
          });
      });
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sa_my_customer/getReservationHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        status: vm.nowSelectStatus,
        m_id: vm.customerData.user.member_id,
        event_type: vm.selectType.id
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeTypeHandler(type) {
      const vm = this;
      switch (type) {
        case '客戶資料':
          if (vm.nowSelectItem === '客戶資料') return;
          vm.nowSelectItem = '客戶資料';
          break;
        case '預約紀錄':
          if (vm.nowSelectItem === '預約紀錄') return;
          vm.nowSelectItem = '預約紀錄';
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'reserving':
          if (vm.nowSelectStatus === 'reserving') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'reserving');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checked':
          if (vm.nowSelectStatus === 'checked') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'checked');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelectStatus === 'success') return;
          vm.$store.commit('sa_my_customer/changeSelectStatus', 'success');
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
      }
    },
    editModeHandler() {
      const vm = this;
      if (!vm.editMode) {
        vm.editMode = true;
      } else {
        vm.$swal.fire({
          title: '請稍候，\n備註名儲存中',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sa_my_customer/updateMemberNoteNameHandler', {
          memberId: vm.memberInfo.member_id,
          note_name: vm.noteName
        })
          .then(() => {
            vm.$swal.close();
            vm.$snotify.success(null, '備註名儲存成功');
            vm.editMode = false;
          });
      }
    },
    updateDescriptionHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n客戶描述儲存中',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sa_my_customer/updateMemberDescHandler', {
        memberId: vm.memberInfo.member_id,
        desc: vm.desc
      })
        .then(() => {
          vm.$swal.close();
          vm.$snotify.success(null, '客戶描述儲存成功');
          vm.editMode = false;
        });
    },
    cancelReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n取消預約中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/deleteHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '取消確認成功');
        });
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_MY_CUSTOMER_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          userId: this.customerData.user.member_id,
          editInfo: reservation
        }
      });
    },
    editEventReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_EVENT_ACTIVITY_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
        }
      });
    },
    confirmReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n預約確認中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/checkHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '預約確認成功');
        });
    },
    doneReservationHandler(reservationId) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n完成預約中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_my_customer/successHandler', {
        reservation_id: reservationId
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sa_my_customer/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '完成預約成功');
        });
    },
    removeLabelHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n標籤移除中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      // 儲存
      setTimeout(() => {
        vm.$store.dispatch('sa_my_customer/storeTagsHandler', {
          member_uuid: vm.memberInfo.member_line_uuid,
          tags: vm.userLabels
        })
          .then(() => {
            // 初始化標籤
            vm.initTagsHandler();
            vm.$swal.close();
            vm.$snotify.success(null, '標籤移除成功');
          });
      }, 50);
    },
    selectLabelHandler(event) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n替客戶加上標籤中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 儲存
      vm.$store.dispatch('sm_my_customer/storeTagsHandler', {
        member_uuid: vm.memberInfo.member_line_uuid,
        tags: [event, ...vm.userLabels]
      })
        .then(() => {
          // 初始化標籤
          vm.initTagsHandler();
          vm.$swal.close();
          vm.$snotify.success(null, '客戶新增標籤成功');
        });
    },
    // 初始化標籤
    initTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n標籤載入中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得所有標籤
      vm.$store.dispatch('sa_my_customer/getTagsHandler')
        .then(() => {
          // 這邊先寫死拿後端的標籤，以後有時間再來改
          vm.$set(vm, 'tagsOption', vm.tags ? vm.tags[1].tag : []);
          // 取得該使用者的標籤
          vm.$store.dispatch('sa_my_customer/getMemberTagsHandler', vm.memberInfo.member_line_uuid)
            .then(() => {
              vm.$set(vm, 'userLabels', vm.memberTags);
              vm.$swal.close();
            });
        });
    },
    goToChatRoomHandler() {
      const vm = this;
      vm.$router.push({
        name: SA_CHAT_ROOM_INDEX,
        params: {
          chatRoomTitle: `與${vm.memberInfo.display_name || vm.memberInfo.line_display_name}對話`,
          user: vm.memberInfo,
          sa_id: vm.sa_id
        }
      });
    }
  },
  computed: {
    ...mapState({
      sa_id: (state) => state.sa_msg_manager.sa_id,
      reservations: (state) => state.sa_my_customer.reservations,
      reservationTimeList: (state) => state.sa_my_customer.reservationTimeList,
      pagination: (state) => state.sa_my_customer.pagination,
      nowSelectStatus: (state) => state.sa_my_customer.nowSelectStatus,
      memberInfo: (state) => state.sa_my_customer.memberInfo,
      tags: (state) => state.sa_my_customer.tags,
      memberTags: (state) => state.sa_my_customer.memberTags,
      TRList: (state) => state.sa.TRList,
      genderList: (state) => state.sa.genderList,
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('sa_my_customer/resetHandler');
    if (to.name !== 'sa-event-activity-reservation-edit' && to.name !== 'sa-my-customer-reservation-edit') {
      window.sessionStorage.removeItem('user');
      window.sessionStorage.removeItem('filter_type');
    }
    next();
  }
};
</script>

<style>

</style>
